// Use theme's Minicart 


BoostOTP.AjaxCart.prototype.isRender = function() { return false; }
    
  // Prevent call cart.js after adding a product
BoostOTP.AjaxCart.prototype.getCart = function(isOpenCart) {}

  // Customize Success add to Cart method
  var onSuccessAddToCart = BoostOTP.AjaxCart.prototype.onSucess;

BoostOTP.AjaxCart.prototype.onSucess = function(data, $addingLabel, $errorLabel) {
    console.log(data)
    onSuccessAddToCart.call(this, data, $addingLabel, $errorLabel);

    // Call theme function
    // PXUTheme.jsAjaxCart.showDrawer()
    // PXUTheme.jsAjaxCart.updateView()
    window.NSCart.open()
}